// The quote-wide manufacturing-lines source, held on window.frank_manufacturing_lines_source so every Frank URL
// builder reads the SAME value the /mcc header / wizard toggle last set. The server persists it per quote
// (user_quotes.manufacturing_lines_source, seeded into the global by frank/edit.html.erb); this is the live,
// in-page copy that a live toggle updates before the sections remount and re-fetch.
//
//   'standard' -- the shared example account (QUOTE_BUILDER_EXAMPLE_ACCOUNT), the default.
//   'own'      -- the quote owner's OWN configured machines and materials.
export const STANDARD = 'standard';
export const OWN = 'own';

export const manufacturingLinesSource = () => window.frank_manufacturing_lines_source || STANDARD;

export const setManufacturingLinesSource = (value) => {
  window.frank_manufacturing_lines_source = value;
};

// Append the source to a Frank fetch's URLSearchParams, so the browser and server answer caches -- both keyed by
// the request -- never reuse a Standard answer for an Own request (and vice versa). The DEFAULT (standard) is
// omitted rather than spelled out: the server, the browser cache and the fingerprint all treat an absent value
// as standard, so leaving it off keeps every existing Standard request byte-identical and only the new Own path
// carries a param.
export const appendManufacturingLinesSource = (params) => {
  const source = manufacturingLinesSource();
  if (source !== STANDARD) { params.set('manufacturing_lines_source', source); }
  return params;
};
